/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MetricValueLatestRequestDto
 */
export interface MetricValueLatestRequestDto {
    /**
     * Metric code to retrieve the latest daily value for. The response is the total (sum) of all records on the most recent day that has data.
     * @type {string}
     * @memberof MetricValueLatestRequestDto
     */
    metricCode: MetricValueLatestRequestDtoMetricCodeEnum;
    /**
     * Filter by specific health provider code
     * @type {string}
     * @memberof MetricValueLatestRequestDto
     */
    healthProviderCode?: MetricValueLatestRequestDtoHealthProviderCodeEnum;
    /**
     * Only consider records on or after this date (ISO 8601 format)
     * @type {string}
     * @memberof MetricValueLatestRequestDto
     */
    startDate?: string;
    /**
     * Only consider records on or before this date (ISO 8601 format)
     * @type {string}
     * @memberof MetricValueLatestRequestDto
     */
    endDate?: string;
    /**
     * Timezone offset in HHMM format (e.g. +0700 for UTC+7, -0500 for UTC-5). When set with date-only startDate/endDate, those dates are interpreted in this timezone.
     * @type {string}
     * @memberof MetricValueLatestRequestDto
     */
    timezoneOffset?: string;
    /**
     * Hour (0–23) used as the day boundary when grouping records into days. When set, a record belongs to day N if its endDate falls between <dayBoundaryHour> on day N-1 and <dayBoundaryHour> on day N. Use 19 for 7pm sleep window attribution.
     * @type {number}
     * @memberof MetricValueLatestRequestDto
     */
    dayBoundaryHour?: number;
}


/**
 * @export
 */
export const MetricValueLatestRequestDtoMetricCodeEnum = {
    StepCounts: 'step-counts',
    Distance: 'distance',
    ActiveCalories: 'active-calories',
    Workouts: 'workouts',
    FloorClimbed: 'floor-climbed',
    HeartRate: 'heart-rate',
    HeartRateVariability: 'heart-rate-variability',
    BloodOxygenSaturation: 'blood-oxygen-saturation',
    RespiratoryRate: 'respiratory-rate',
    RestingHeartRate: 'resting-heart-rate',
    BasalMetabolicRate: 'basal-metabolic-rate',
    BodyTemperature: 'body-temperature',
    BloodPressure: 'blood-pressure',
    BloodGlucose: 'blood-glucose',
    Weight: 'weight',
    Height: 'height',
    WaistCircumference: 'waist-circumference',
    HipCircumference: 'hip-circumference',
    BodyMassIndex: 'body-mass-index',
    BodyFatPercentage: 'body-fat-percentage',
    LeanBodyMass: 'lean-body-mass',
    BoneMass: 'bone-mass',
    SleepAnalysis: 'sleep-analysis',
    SleepStages: 'sleep-stages',
    SleepSessionEvents: 'sleep-session-events',
    TimeInBed: 'time-in-bed',
    SleepTime: 'sleep-time',
    ActualSleepTime: 'actual-sleep-time',
    Nutrition: 'nutrition',
    Calories: 'calories',
    Protein: 'protein',
    Carbohydrates: 'carbohydrates',
    TotalFat: 'total-fat',
    SaturatedFat: 'saturated-fat',
    MonounsaturatedFat: 'monounsaturated-fat',
    PolyunsaturatedFat: 'polyunsaturated-fat',
    Cholesterol: 'cholesterol',
    Micronutrients: 'micronutrients',
    Hydration: 'hydration',
    Menstruation: 'menstruation',
    OvulationTestResults: 'ovulation-test-results',
    WellBeing: 'well-being'
} as const;
export type MetricValueLatestRequestDtoMetricCodeEnum = typeof MetricValueLatestRequestDtoMetricCodeEnum[keyof typeof MetricValueLatestRequestDtoMetricCodeEnum];

/**
 * @export
 */
export const MetricValueLatestRequestDtoHealthProviderCodeEnum = {
    AppleHealthkit: 'apple-healthkit',
    GoogleHealthConnect: 'google-health-connect'
} as const;
export type MetricValueLatestRequestDtoHealthProviderCodeEnum = typeof MetricValueLatestRequestDtoHealthProviderCodeEnum[keyof typeof MetricValueLatestRequestDtoHealthProviderCodeEnum];


/**
 * Check if a given object implements the MetricValueLatestRequestDto interface.
 */
export function instanceOfMetricValueLatestRequestDto(value: object): value is MetricValueLatestRequestDto {
    if (!('metricCode' in value) || value['metricCode'] === undefined) return false;
    return true;
}

export function MetricValueLatestRequestDtoFromJSON(json: any): MetricValueLatestRequestDto {
    return MetricValueLatestRequestDtoFromJSONTyped(json, false);
}

export function MetricValueLatestRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetricValueLatestRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'metricCode': json['metricCode'],
        'healthProviderCode': json['healthProviderCode'] == null ? undefined : json['healthProviderCode'],
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
        'timezoneOffset': json['timezoneOffset'] == null ? undefined : json['timezoneOffset'],
        'dayBoundaryHour': json['dayBoundaryHour'] == null ? undefined : json['dayBoundaryHour'],
    };
}

export function MetricValueLatestRequestDtoToJSON(json: any): MetricValueLatestRequestDto {
    return MetricValueLatestRequestDtoToJSONTyped(json, false);
}

export function MetricValueLatestRequestDtoToJSONTyped(value?: MetricValueLatestRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'metricCode': value['metricCode'],
        'healthProviderCode': value['healthProviderCode'],
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'timezoneOffset': value['timezoneOffset'],
        'dayBoundaryHour': value['dayBoundaryHour'],
    };
}

